import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { AddEditMetaComponent } from 'src/app/modules/content/add-edit-meta/add-edit-meta.component';
import { ETemplateTypes } from 'src/app/models/general-enums';

@Component({
  selector: 'app-add-edit-page-template',
  templateUrl: './add-edit-page-template.component.html',
  styleUrls: ['./add-edit-page-template.component.css']
})
export class AddEditPageTemplateComponent implements OnInit {
  isEditPage: boolean = false;
  enumArrType;
  template: any = {};
  allLayouts: any[];
  indexToEdit: number = null;
  tempMeta: any = {};
  duplicated: any;
  viewTemplateSetting: any;
  formInfo = {
    editMode: false,
    targetIndex: 0,
  };

  @Input() data: any;
  @Output() result = new EventEmitter<any>();

  public seoForm = new FormGroup({
    tags: new FormArray([]),
    tagsArray: new FormArray([]),
    addtionalMeta: new FormControl(false),
  });

  constructor(private httpClient: HttpClient, private dialog: MatDialog,
  ) { }

 
  getETemplateTypes() {
    this.enumArrType = [];
    for (let item in ETemplateTypes) {
      if (isNaN(Number(item))) {
        this.enumArrType.push({name:item, value: ETemplateTypes[item]});
      }
    }
  }
  ngOnInit() {
    this.getETemplateTypes();
    this.template.addtionalMeta = false
    this.template.id = this.data.id ? this.data.id : 0
    this.template.duplicatingId = this.data.duplicatingId ? this.data.duplicatingId : 0
    this.template.Name = this.data.name ? this.data.name : ''
    this.template.Description = this.data.description ? this.data.description : ''
    this.template.Type = this.data.type ? this.data.type : 1
    this.template.addtionalMetaTags = this.data.addtionalMetaTags ? JSON.parse(this.data.addtionalMetaTags) : []

    if (this.template.addtionalMetaTags.length == 0) {
      this.template.addtionalMeta = false
    } else this.template.addtionalMeta = true

    if (this.template.duplicatingId) {
      this.template.Name = this.data.name + ' (Duplicated)'
    }

    let tagsArray;

    if (this.template.id) {
      if (this.template.addtionalMetaTags) {
        if (Array.isArray(this.template.addtionalMetaTags)) {
          tagsArray = this.template.addtionalMetaTags;
        }
      }
      this.setArray(tagsArray || []);

    }
    this.addToTags();
  }

  back() {
    window.history.back();
  }

  AddMeta() {

    if (this.indexToEdit == null)

      this.template.addtionalMetaTags.push(this.tempMeta);
    else
      this.template.addtionalMetaTags[this.indexToEdit] = JSON.parse(JSON.stringify(this.tempMeta))
    this.indexToEdit = null;
    this.tempMeta = {}
  }

  editMeta(m, i) {
    this.tempMeta = JSON.parse(JSON.stringify(m));
    this.indexToEdit = i;
  }


  saveTemplate(form) {
    if (form.invalid)
      return

    const data = {
      Name: this.template.Name,
      Description: this.template.Description,
      Type: form.controls['Type'].value,
      AddtionalMetaTags: JSON.stringify(this.seoForm.controls["tagsArray"].value) || null,
      Status: 2
    }

    if (this.data.id) {
      this.isEditPage = true;
      this.httpClient.post('/PageTemplate/EditPageTemplates/' + this.template.id, data).subscribe((res: any) => {
        if (res.isSuccessStatusCode == false)
          this.result.emit("error");
        else
          this.result.emit("add");
      });
    } else {
      if (this.template.duplicatingId) {
        this.isEditPage = true;
        this.httpClient.post(`/PageTemplate/DuplicateTemplate/${this.template.duplicatingId}`, data).subscribe((res: any) => {
          if (res.isSuccessStatusCode == false)
            this.result.emit("error");
          else
            this.result.emit("add");
        });
      } else {
        this.httpClient.post('/PageTemplate/AddPageTemplates', data).subscribe((res: any) => {
          if (res.isSuccessStatusCode == false)
            this.result.emit("error");
          else
            this.result.emit("add");
        });
      }


    }


  }


  setArray(value) {
    for (let v of value) {
      if (Array.isArray(v)) {
        this.flatArray(v);
      }
    }
  }
  flatArray(v) {
    var arr = new FormArray([]);
    v.forEach((element) => {
      const fg = Object.keys(element).reduce(
        (obj, key) =>
          Object.assign(obj, { [key]: new FormControl(element[key]) }),
        {}
      );
      arr.push(new FormGroup(fg));
    });
    this._tagsArray.push(arr);
  }

  setTagsArray(value) {
    const arr = new FormArray([]);
    for (let v of value) {
      const fg = Object.keys(v).reduce(
        (obj, key) => Object.assign(obj, { [key]: new FormControl(v[key]) }),
        {}
      );
      arr.push(new FormGroup(fg));
    }
    return arr;
  }

  addToTags() {
    this._tags.push(
      new FormGroup({
        key: new FormControl("", [Validators.required]),
        value: new FormControl("", [Validators.required]),
      })
    );
  }

  removeTag(i) {


    if (this.formInfo.editMode) {

      this.formInfo.editMode = false;
      this._tagsArray.removeAt(i);
      this.seoForm.setControl("tags", this.setTagsArray(this.seoForm.value.tags));
    }

    this._tags.removeAt(i);
  }

  removeControl(i) {

    if (this.formInfo.editMode) {

      this.formInfo.editMode = false;
      //this._tagsArray.removeAt(i);

      this.seoForm.setControl("tags", new FormArray([]));
      this.addToTags();
    }
    this._tags.removeAt(i);
  }

  removeMetaTag(fa: FormArray, index: number) {
    fa.removeAt(index)
  }

  addToTagsArr() {
    const value = this._tags.value;
    const arr = new FormArray([]);
    for (let v of value) {
      const fg = Object.keys(v).reduce(
        (obj, key) => Object.assign(obj, { [key]: new FormControl(v[key]) }),
        {}
      );
      arr.push(new FormGroup(fg));
    }

    if (this.formInfo.editMode) {
      this._tagsArray.removeAt(this.formInfo.targetIndex);
      this._tagsArray.insert(this.formInfo.targetIndex, arr);
      this.formInfo.editMode = false;
    } else {
      this._tagsArray.push(arr);

    }

    this.tempMeta = this._tagsArray.value;
    this.seoForm.setControl("tags", new FormArray([]));
    this.addToTags();


  }

  editTagsArrayItem(item, i) {
    const data = [...item];
    // this._tagsArray.removeAt(i);
    this.formInfo.editMode = true;
    this.formInfo.targetIndex = i;

    this.seoForm.setControl("tags", this.setTagsArray(data));
    this._tagsArray.removeAt(i);

  }

  manageMeta(method: string, fg: FormGroup, metaTag?: any, index?: number) {
       const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;

    if (metaTag) {
      dialogConfig.data = metaTag;
    }

    this.dialog.open(AddEditMetaComponent, dialogConfig,)
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            switch (method) {
              case 'add':
                (fg.get('tagsArray') as FormArray).push(res);
                break;

              case 'edit':
                (fg.get('tagsArray') as FormArray).removeAt(index);
                (fg.get('tagsArray') as FormArray).insert(index, res);
            }
          }
        }
      )
  }


  close() {
    this.result.emit(0);
  }

  get _tags() {
    return this.seoForm.get("tags") as FormArray;
  }

  get _tagsArray() {
    return this.seoForm.get("tagsArray") as FormArray;
  }

  get _addtionalMeta() {
    return this.seoForm.get("addtionalMeta");
  }

}
function AddtionalMetaTags(arg0: string, AddtionalMetaTags: any) {
  throw new Error('Function not implemented.');
}

